import React, {useRef, useEffect, useState} from 'react';

const CrossOriginIframe = ({src, width, height, failContent = "Failed to load content.", embedGame = false, embedItchPage = false}) => {
    const iframeRef = useRef(null);
    const [hasFailed, setHasFailed] = useState();
    // const [loading, setLoading] = useState(true);

    const displaySrc = src && src.trim() !== "";

    useEffect(() => {
        const checkIframeSrc = () => {
            if (iframeRef.current) {
                // Accessing the src attribute from the DOM element
                const iframeSrc = iframeRef.current.src;
                if (iframeSrc.includes("PatternLibrary")) {
                    setHasFailed(true);
                }
            }
        };
        setHasFailed(false);

        if (iframeRef.current) {
            iframeRef.current.onload = checkIframeSrc;
        }

        if (embedGame && !src.includes("https://itch.io/embed-upload") && !src.includes("https://html-classic.itch.zone")) {
            setHasFailed(true);
        } else if (embedItchPage && !src.includes("https://itch.io/embed/")) {
            setHasFailed(true);
        }

    }, [src, embedGame, embedItchPage]);

    return (
        displaySrc ?
        <div>
            {hasFailed ?
                <div style={{width: "100%", alignSelf: "center"}}>{failContent}</div>
                : <iframe
                    ref={iframeRef}
                    frameBorder={0}
                    src={src}
                    width={width}
                    height={height}
                    title="iframe"
                    allowFullScreen
                    onError={() => setHasFailed(true)}
                />}
        </div>
        : null
    );
};

export default CrossOriginIframe;
